export default "__VITE_ASSET__hZ2INJls__"